module.exports = __webpack_public_path__ + "static/media/fatf-guidance.846bd863.pdf";